import { render } from "./CurrentLocationCard.vue?vue&type=template&id=57484435&scoped=true"
import script from "./CurrentLocationCard.vue?vue&type=script&lang=js"
export * from "./CurrentLocationCard.vue?vue&type=script&lang=js"

import "./CurrentLocationCard.vue?vue&type=style&index=0&id=57484435&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57484435"]])

export default __exports__